import { organizationInterceptorFn } from './organization-interceptor.function';

export const ORGANIZATION_HTTP_INTERCEPTORS = [
  organizationInterceptorFn,
];
